// extracted by mini-css-extract-plugin
module.exports = {"reel":"Reel_reel__Aeqpy","hybridReel":"Reel_hybridReel__hCEd0"};